import React from 'react';

interface SectionProps {
	title: string;
	count?: number;
	children: React.ReactNode;
}

export function Section({title, count, children}: SectionProps): React.ReactElement {
	return (
		<section className="mb-12 last:mb-0">
			<div className="flex items-center gap-1 mb-7">
				<h2 className="text-2xl font-medium text-black">{title}</h2>
				{count != null && <span className="-mt-3">{count}</span>}
			</div>
			{children}
		</section>
	);
}
